"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRetryErrorSwrOptions = exports.errorHandlingSwrOptions = exports.basicSwrOptions = void 0;
var _axios = require("@ori/axios");
var _showErrorNotification = require("../utils/showErrorNotification");
const basicSwrOptions = exports.basicSwrOptions = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false
};
const ERROR_RETRY_COUNT = 3;
const ERROR_RETRY_INTERVAL = 2000;
const errorHandlingSwrOptions = exports.errorHandlingSwrOptions = {
  ...basicSwrOptions,
  onError: () => (0, _showErrorNotification.showErrorNotification)()
};
const getRetryErrorSwrOptions = () => ({
  ...errorHandlingSwrOptions,
  shouldRetryOnError: true,
  errorRetryCount: ERROR_RETRY_COUNT,
  errorRetryInterval: ERROR_RETRY_INTERVAL,
  // eslint-disable-next-line max-params -- library requires too many parameters
  onErrorRetry: (error, _, config, revalidate, {
    retryCount
  }) => {
    const statusCode = error.response?.status ?? _axios.HttpStatusCode.GatewayTimeout;
    if (statusCode >= _axios.HttpStatusCode.BadRequest && statusCode < _axios.HttpStatusCode.InternalServerError) {
      return;
    }
    if (retryCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({
      retryCount
    }), config.errorRetryInterval);
  }
});
exports.getRetryErrorSwrOptions = getRetryErrorSwrOptions;
//# sourceMappingURL=swrConfig.js.map